import { fromJS } from 'immutable'
import {
  LEAVE_REQUEST_APPROVE_REQUEST,
  LEAVE_REQUEST_APPROVE_SUCCESS,
  LEAVE_REQUEST_APPROVE_FAILURE,
  LEAVE_REQUEST_APPROVE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LEAVE_REQUEST_APPROVE_REQUEST:
      return state
        .set('isFetching', true)
    case LEAVE_REQUEST_APPROVE_SUCCESS:
      return state
        .set('updatedLeaveRequest', fromJS(action.payload.updatedLeaveRequest))
        .set('status', 200)
        .set('isFetching', false)
        // .set('message', fromJS(action.payload.response.message))
    case LEAVE_REQUEST_APPROVE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('updatedLeaveRequest', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LEAVE_REQUEST_APPROVE_RESET:
      return state
        .delete('updatedLeaveRequest')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leave-request/leave-request-approve-reducer.js